import { UserStore } from '@yarmill/types';

export function sortUserStores(a: UserStore, b: UserStore): number {
  return a.displayName
    .toLocaleLowerCase()
    .localeCompare(b.displayName.toLocaleLowerCase(), 'cs');
}
